import i18n from 'i18next';
import { superAxios } from '../../../shared/utils/axios';
import { addToast } from '../toasts/toastsActions';
import { toastTypes } from '../../../shared/components/Toast/ToastOptions';
import { actionSuccess } from '../utils';

export const FETCH_EMAILQUEUE = 'FETCH_EMAILQUEUE';
export const POST_EMAILQUEUE = 'POST_EMAILQUEUE';
export const DELETE_EMAILQUEUE = 'DELETE_EMAILQUEUE';

const emailQueueEndpoint = `${process.env.REACT_APP_API_URL}super/email-queue`;

export const fetchEmailQueue = () => async dispatch => {
  try {
    const response = await superAxios.get(emailQueueEndpoint);
    dispatch(actionSuccess(FETCH_EMAILQUEUE, response?.data?.data));

    return response?.data;
  } catch (error) {
    dispatch(addToast(toastTypes.error, error));
  }
};

export const postEmailQueue = payload => async dispatch => {
  try {
    const postEmail = await superAxios.post(emailQueueEndpoint, payload);
    dispatch(actionSuccess(POST_EMAILQUEUE, postEmail?.data));

    dispatch(
      addToast({
        ...toastTypes.success,
        defaultMessage: i18n.t('emailQueue.post.success', {
          ns: 'actions'
        })
      })
    );
  } catch (error) {
    dispatch(addToast(toastTypes.error, error));
  }
};

export const deleteEmailQueue = payload => async dispatch => {
  try {
    const postEmail = await superAxios.post(`${emailQueueEndpoint}/delete`, payload);
    dispatch(actionSuccess(DELETE_EMAILQUEUE, postEmail?.data?.data));

    dispatch(
      addToast({
        ...toastTypes.success,
        defaultMessage: i18n.t('emailQueue.delete.success', {
          ns: 'actions'
        })
      })
    );
  } catch (error) {
    dispatch(addToast(toastTypes.error, error));
  }
};
